"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from "react";
import { scrollToTop as smoothScrollToTop } from "@/lib/utils/scroll";
import DesktopActions from "./DesktopActions";
import MobileActionBar from "./MobileActionBar";
import NavigationOverlay from "./NavigationOverlay";
import { menuData } from "@/data/MenuData";
const FloatingActions = () => {
  const $ = _c(16);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolledEnough, setScrolledEnough] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => setScrolledEnough(window.scrollY > 150);
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const scrollToTop = _temp;
  const t2 = scrolledEnough && !isMenuOpen;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsMenuOpen(true);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <MobileActionBar visible={t2} onOpenMenu={t3} onScrollTop={scrollToTop} />;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsMenuOpen(_temp2);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isMenuOpen || $[7] !== scrolledEnough) {
    t6 = <DesktopActions visible={scrolledEnough} isMenuOpen={isMenuOpen} onToggleMenu={t5} onScrollTop={scrollToTop} />;
    $[6] = isMenuOpen;
    $[7] = scrolledEnough;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsMenuOpen(false);
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMenuOpen) {
    t8 = <NavigationOverlay isOpen={isMenuOpen} onClose={t7} menuItems={menuData.navMenu} revealPoint="circle(0% at calc(100% - 40px) 28px)" />;
    $[10] = isMenuOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t6 || $[14] !== t8) {
    t9 = <>{t4}{t6}{t8}</>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default FloatingActions;
function _temp() {
  return smoothScrollToTop();
}
function _temp2(open) {
  return !open;
}